import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { type Observable } from "rxjs";
import {
	type Message,
	type SendMessageInput,
	type Template,
} from "src/app/schema";
import { ApiService, CognitoService } from "src/app/services";

export type TemplatedPreview = {
	id: string;
	subject: string;
	contents: string;
};

@Injectable({
	providedIn: "root",
})
export class MessageService {
	private readonly _httpClient = inject(HttpClient);
	private readonly _api = inject(ApiService);
	private readonly _cognitoService = inject(CognitoService);

	public sendMessage(message: SendMessageInput): Observable<Message> {
		return this._httpClient.post<Message>(
			`${this._api.communicationsApiEndpoint}/leads/${message.leadId}/messages/send`,
			message,
		);
	}

	public getMessagePreview(messageId: string): Observable<TemplatedPreview> {
		return this._httpClient.get<TemplatedPreview>(
			`${this._api.communicationsApiEndpoint}/messages/${messageId}/preview`,
		);
	}

	public getTemplatePreview(
		template: string,
		leadId: string,
		propertyId: string,
	): Observable<Template> {
		return this._httpClient.get<Template>(
			`${this._api.communicationsApiEndpoint}/properties/${propertyId}/templates/${template}/leads/${leadId}/preview`,
		);
	}

	public sendTemplatedMessage(
		template: string,
		leadId: string,
		propertyId: string,
	): Observable<Template> {
		return this._httpClient.post<Template>(
			`${this._api.communicationsApiEndpoint}/properties/${propertyId}/templates/${template}/leads/${leadId}/send`,
			{ userId: this._cognitoService.user().id },
		);
	}
}
